import { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

const TabSection = ({ heading }) => {



  // State to manage the active tab
  const [activeTab, setActiveTab] = useState(1);
  useEffect(() => {
    AOS.init({
      duration: 1000, // Animation duration in milliseconds
      once: true, // Animation happens only once while scrolling down
    });
  }, []);


  const tabs = [
    { id: 1, label: "Popular Tours" },
    { id: 2, label: "Science Tours" },
    { id: 3, label: "Art and Design" },
    { id: 4, label: "Technology Tours" },

    { id: 5, label: "Sports tour" },
    { id: 6, label: "Others" },
  ];
  // Example content for each tab (image data)
  const tabContent = {
    1: [
      {
        id: 11,
        imgSrc: 'https://media.istockphoto.com/id/124420314/photo/camel-resting-outside-a-city.jpg?s=612x612&w=0&k=20&c=6QWimjtHOzPnkA1UNk5EK2E7ZfrNY7zl2XrnLBgz1lw=',
        title: 'Dubai Tour',
      },
      {
        id: 4,
        imgSrc: 'https://imgs.search.brave.com/zD_OgvQczzFTRpsP7jmNwNMQhY1WeQZlHvcbq43teo8/rs:fit:500:0:0:0/g:ce/aHR0cHM6Ly9jZG4u/cHJvZC53ZWJzaXRl/LWZpbGVzLmNvbS81/ZGMwMzRiMzRjYTIx/YjA5YTUyMTZjNTEv/NjNiNmQzOWM2MmY0/YzhkOGNlZGY1M2M4/X3FRZmxpOVR0WWdI/MXVfSXhmSkl5ZTVL/M01WOUJ5dVZFNzJX/cjNzTEhKaEUuanBl/Zw',
        title: 'London Tour',
      },
      {
        id: 6,
        imgSrc: 'https://imgs.search.brave.com/pFSX5yJ80w-w5iDnLecGivsyjeGo6S9ifqIPbWcWq2w/rs:fit:500:0:0:0/g:ce/aHR0cHM6Ly93d3cu/ZWR1Y2F0aW9uYWxz/Y2hvb2x0cmlwLmNv/bS93cC1jb250ZW50/L3VwbG9hZHMvbWVy/bGlvbi1wYXJrLXNp/bmdhcG9yZS02MDB4/NDAwLmpwZw',
        title: 'Singapore Tour',
      },
      {
        id: 2,
        imgSrc: 'https://imgs.search.brave.com/bMmjpBB8uXGMU9Zt7bwpJAQ_S0kTBqc5sGRXJ47NlWE/rs:fit:500:0:0:0/g:ce/aHR0cHM6Ly9tZWRp/YS5nZXR0eWltYWdl/cy5jb20vaWQvNjQy/MzQ1Mjk2L3Bob3Rv/L2ZsYWdzLW9mLW1l/bWJlci1jb3VudHJp/ZXMtb2YtdW5pdGVk/LW5hdGlvbnMtaW4t/dW4tY29tcGxleC5q/cGc_cz02MTJ4NjEy/Jnc9MCZrPTIwJmM9/R2UtTHNLdFZsdnRr/dU5DS3VSdnpiQW9h/WElMWWw4amJ3WUxU/ZmFxbkVldz0',
        title: 'United Nations Tour',
      },
      {
        id: 12,
        imgSrc: 'https://imgs.search.brave.com/1fOWWEv1jenpMc0WWOndqgLGsF9cVsU6v3YhMPsgILk/rs:fit:500:0:0:0/g:ce/aHR0cHM6Ly93d3cu/ZWR1Y2F0aW9uYWxz/Y2hvb2x0cmlwLmNv/bS93cC1jb250ZW50/L3VwbG9hZHMvc3R1/ZGVudHMtdmlzaXQt/U2Vuc29qaS1UZW1w/bGUtaW4tSmFwYW4t/c2Nob29sLXRvdXIt/LTYwMHg0MDAuanBn',
        title: 'Japan Tour',
      },
    ],
    2: [
      {
        id: 4,
        imgSrc: 'https://media-cdn.tripadvisor.com/media/attractions-splice-spp-674x446/09/12/08/97.jpg',
        title: 'USA Tour',
      },
      {
        id: 2,
        imgSrc: 'https://imgs.search.brave.com/bMmjpBB8uXGMU9Zt7bwpJAQ_S0kTBqc5sGRXJ47NlWE/rs:fit:500:0:0:0/g:ce/aHR0cHM6Ly9tZWRp/YS5nZXR0eWltYWdl/cy5jb20vaWQvNjQy/MzQ1Mjk2L3Bob3Rv/L2ZsYWdzLW9mLW1l/bWJlci1jb3VudHJp/ZXMtb2YtdW5pdGVk/LW5hdGlvbnMtaW4t/dW4tY29tcGxleC5q/cGc_cz02MTJ4NjEy/Jnc9MCZrPTIwJmM9/R2UtTHNLdFZsdnRr/dU5DS3VSdnpiQW9h/WElMWWw4amJ3WUxU/ZmFxbkVldz0',
        title: 'United Nations Tour',
      },
      {
        id: 12,
        imgSrc: 'https://imgs.search.brave.com/1fOWWEv1jenpMc0WWOndqgLGsF9cVsU6v3YhMPsgILk/rs:fit:500:0:0:0/g:ce/aHR0cHM6Ly93d3cu/ZWR1Y2F0aW9uYWxz/Y2hvb2x0cmlwLmNv/bS93cC1jb250ZW50/L3VwbG9hZHMvc3R1/ZGVudHMtdmlzaXQt/U2Vuc29qaS1UZW1w/bGUtaW4tSmFwYW4t/c2Nob29sLXRvdXIt/LTYwMHg0MDAuanBn',
        title: 'Japan Tour',
      },
      {
        id: 7,
        imgSrc: 'https://imgs.search.brave.com/oOZEFtzGH-kjPc4LYsMC9vXsTrS_U9U-GRkY2gxOV8E/rs:fit:500:0:0:0/g:ce/aHR0cHM6Ly9nb3dp/dGhndWlkZS5jb20v/aW1hZ2VzL3RUM3Iw/V0xpTHpsWmE2TThY/YmQyRGxaT0NOTnQx/YUQzS1dqVXQzd1pL/UE0vZjphdmlmL2g6/NDgwL3c6NDgwL3Bs/YWluL2dvd2l0aGd1/aWRlL2NpdGllcy8y/MTk1LzkyNjUxLmpw/Zw',
        title: 'South Korea Tour',
      },
    ],
    3: [
      {
        id: 3,
        imgSrc: 'https://imgs.search.brave.com/RFXD52NyFgf8GqvyjdJnDfShwUdWw_CCUnjvCvQ05aA/rs:fit:500:0:0:0/g:ce/aHR0cHM6Ly9tZWRp/YS5nZXR0eWltYWdl/cy5jb20vaWQvNDY0/MjE4NDc3L3Bob3Rv/L3N5ZG5leS1vcGVy/YS1ob3VzZS1hbmQt/c2t5bGluZS5qcGc_/cz02MTJ4NjEyJnc9/MCZrPTIwJmM9elBn/RDVuRFdqRE15NmVS/dF9DSDFLLVRkVlA0/alJ1LWw0VjQ2YUhf/NnBNST0',
        title: 'Australia Tour',
      },
      {
        id: 4,
        imgSrc: 'https://imgs.search.brave.com/zD_OgvQczzFTRpsP7jmNwNMQhY1WeQZlHvcbq43teo8/rs:fit:500:0:0:0/g:ce/aHR0cHM6Ly9jZG4u/cHJvZC53ZWJzaXRl/LWZpbGVzLmNvbS81/ZGMwMzRiMzRjYTIx/YjA5YTUyMTZjNTEv/NjNiNmQzOWM2MmY0/YzhkOGNlZGY1M2M4/X3FRZmxpOVR0WWdI/MXVfSXhmSkl5ZTVL/M01WOUJ5dVZFNzJX/cjNzTEhKaEUuanBl/Zw',
        title: 'London Tour',
      },
    ],
    4: [
      {
        id: 5,
        imgSrc: 'https://imgs.search.brave.com/4wbvi3ZzTSTsCIHbPKBjquXHYBE3kGmeHThibeVZnSI/rs:fit:500:0:0:0/g:ce/aHR0cHM6Ly9jZG4u/cHJvZC53ZWJzaXRl/LWZpbGVzLmNvbS81/YzZjYzg2NDYwMzll/OGY4NGRhYzAzZDgv/NWNkZDMxNTVlMDlm/YTUzZGQwNzRjYjQ5/X1NpbGljb25WYWxs/ZXlfQnVzaW5lc3Ml/MjAoNCkucG5n',
        title: 'Silicon Valley Tour',
      },
      {
        id: 7,
        imgSrc: 'https://imgs.search.brave.com/oOZEFtzGH-kjPc4LYsMC9vXsTrS_U9U-GRkY2gxOV8E/rs:fit:500:0:0:0/g:ce/aHR0cHM6Ly9nb3dp/dGhndWlkZS5jb20v/aW1hZ2VzL3RUM3Iw/V0xpTHpsWmE2TThY/YmQyRGxaT0NOTnQx/YUQzS1dqVXQzd1pL/UE0vZjphdmlmL2g6/NDgwL3c6NDgwL3Bs/YWluL2dvd2l0aGd1/aWRlL2NpdGllcy8y/MTk1LzkyNjUxLmpw/Zw',
        title: 'South Korea Tour',
      },
      {
        id: 12,
        imgSrc: 'https://imgs.search.brave.com/1fOWWEv1jenpMc0WWOndqgLGsF9cVsU6v3YhMPsgILk/rs:fit:500:0:0:0/g:ce/aHR0cHM6Ly93d3cu/ZWR1Y2F0aW9uYWxz/Y2hvb2x0cmlwLmNv/bS93cC1jb250ZW50/L3VwbG9hZHMvc3R1/ZGVudHMtdmlzaXQt/U2Vuc29qaS1UZW1w/bGUtaW4tSmFwYW4t/c2Nob29sLXRvdXIt/LTYwMHg0MDAuanBn',
        title: 'Japan Tour',
      },
      {
        id: 11,
        imgSrc: 'https://media.istockphoto.com/id/124420314/photo/camel-resting-outside-a-city.jpg?s=612x612&w=0&k=20&c=6QWimjtHOzPnkA1UNk5EK2E7ZfrNY7zl2XrnLBgz1lw=',
        title: 'Dubai Tour',
      },
    ],
    5: [
      {
        id: 8,
        imgSrc: 'https://images.pexels.com/photos/1388030/pexels-photo-1388030.jpeg?auto=compress&cs=tinysrgb&w=400',
        title: 'Spain Tour',
      },
      {
        id: 3,
        imgSrc: 'https://imgs.search.brave.com/RFXD52NyFgf8GqvyjdJnDfShwUdWw_CCUnjvCvQ05aA/rs:fit:500:0:0:0/g:ce/aHR0cHM6Ly9tZWRp/YS5nZXR0eWltYWdl/cy5jb20vaWQvNDY0/MjE4NDc3L3Bob3Rv/L3N5ZG5leS1vcGVy/YS1ob3VzZS1hbmQt/c2t5bGluZS5qcGc_/cz02MTJ4NjEyJnc9/MCZrPTIwJmM9elBn/RDVuRFdqRE15NmVS/dF9DSDFLLVRkVlA0/alJ1LWw0VjQ2YUhf/NnBNST0',
        title: 'Australia Tour',
      },
      {
        id: 2,
        imgSrc: 'https://images.pexels.com/photos/1586298/pexels-photo-1586298.jpeg?auto=compress&cs=tinysrgb&w=400',
        title: 'Switzerland Tour',
      },
    ],
    6: [
      {
        id: 13,
        imgSrc: 'https://images.pexels.com/photos/2363/france-landmark-lights-night.jpg?auto=compress&cs=tinysrgb&w=400',
        title: 'Europe Tour',
      },
      {
        id: 14,
        imgSrc: 'https://images.pexels.com/photos/3307194/pexels-photo-3307194.jpeg?auto=compress&cs=tinysrgb&w=600',
        title: 'Finland Tour',
      },
      {
        id: 15,
        imgSrc: 'https://images.pexels.com/photos/756790/pexels-photo-756790.jpeg',
        title: 'Canada Tour',
      },
      {
        id: 16,
        imgSrc: 'https://images.pexels.com/photos/58597/pexels-photo-58597.jpeg?auto=compress&cs=tinysrgb&w=400',
        title: 'Vietnam Tour',
      },
    ],
  };


  return (
    <div className="p-6 bg-white mt-12">
      <header className="text-center mb-10">
        <h1 className="text-2xl md:text-2xl lg:text-4xl notoh font-bold text-gray-800 sm:text-3xl leading-[35px]">
          {heading}
        </h1>
        <p className="text-gray-600 mt-2 text-sm lg:text-2xl">
          Explore our hot selling tours and get Yours
        </p>
      </header>

      <div className="w-full max-w-screen-lg mx-auto">
        {/* Tabs */}
        <div className="flex justify-center overflow-x-auto mb-8 px-0 lg:px-4 ml-5">
          <div className="flex flex-wrap gap-2 sm:space-x-4 bg-white lg:bg-gray-100 rounded-full p-2">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`px-3 sm:px-6 py-2 text-xs lg:text-sm font-medium rounded-full ${activeTab === tab.id
                  ? "bg-blue-600 text-white"
                  : "bg-gray-100 text-gray-700 hover:bg-blue-600 hover:text-white"
                  } transition-all`}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>

        {/* Tab Content */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 justify-center gap-6 lg:gap-8 w-full mx-auto">
          {tabContent[activeTab].map((item) => (
            <div
              key={item.id}
              className="bg-white rounded-lg shadow-lg overflow-hidden w-full hover:shadow-2xl"
              data-aos="fade-up" // AOS attribute for animation
            >
              <img
                src={item.imgSrc}
                alt={item.title}
                className="w-full h-56 md:h-64 lg:h-72 object-cover"
              />
              <div className="p-4">
                <h3 className="text-lg sm:text-xl md:text-2xl font-semibold mb-2">
                  {item.title}
                </h3>
                <a
                  href={`/tours/${item.title.toLowerCase().replace(/\s+/g, '-')}`}
                  rel="noopener noreferrer"
                  className="inline-block text-blue-600 hover:text-blue-800 font-semibold cursor-pointer"
                >
                  Explore More →
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TabSection;
